export default function SipSupport() {
  return (
    <div className="App">
      <h3>Support - SIP Wealth Calculator</h3>
      
      <div style={{ textAlign: 'left', maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
        <h4>Contact Support</h4>
        <p>Need help with SIP Wealth Calculator? We're here to assist you!</p>
        
        <div style={{ backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '5px', margin: '20px 0' }}>
          <h5>📧 Email Support</h5>
          <p><strong>Primary:</strong> sainineeraj1234@gmail.com</p>
          <p><strong>Response Time:</strong> Within 24-48 hours</p>
        </div>

        <h4>Frequently Asked Questions</h4>
        
        <div style={{ marginBottom: '20px' }}>
          <h5>Q: How do I calculate SIP returns?</h5>
          <p>A: Enter your monthly investment amount, expected return rate, and investment duration. The app uses standard SIP formulas to calculate your future value and total returns.</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h5>Q: What is Step-Up SIP?</h5>
          <p>A: Step-Up SIP allows you to increase your monthly investment annually by a specified percentage. This helps you grow your investment as your income increases.</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h5>Q: How does inflation adjustment work?</h5>
          <p>A: The app calculates the real purchasing power of your investment by adjusting for inflation, showing you the actual value of your money in today's terms.</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h5>Q: What currencies are supported?</h5>
          <p>A: The app supports INR (₹), USD ($), EUR (€), and GBP (£) with proper formatting for each currency.</p>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h5>Q: Is the app free to use?</h5>
          <p>A: Yes, SIP Wealth Calculator is a freemium service. Basic calculations are free, with premium features available for advanced analysis, charts, and PDF export.</p>
        </div>

        <h4>App Features</h4>
        <ul>
          <li>✅ SIP Calculator with standard formulas</li>
          <li>✅ Step-Up SIP calculations</li>
          <li>✅ Inflation adjustment</li>
          <li>✅ Multi-currency support (INR, USD, EUR, GBP)</li>
          <li>✅ Interactive charts and visualizations</li>
          <li>✅ PDF export functionality</li>
          <li>✅ Bookmarks to save calculations</li>
          <li>✅ Dark/Light theme support</li>
          <li>✅ Offline functionality</li>
        </ul>

        <h4>Technical Support</h4>
        <p>If you're experiencing technical issues:</p>
        <ul>
          <li>Ensure you have the latest app version</li>
          <li>Check your internet connection (required for premium features)</li>
          <li>Restart the app and try again</li>
          <li>Clear app cache if problems persist</li>
          <li>For iOS: Check App Store connectivity</li>
          <li>For Android: Check Google Play Store connectivity</li>
        </ul>

        <h4>Platform Support</h4>
        <ul>
          <li><strong>iOS:</strong> iOS 13.0+ (iPhone/iPad)</li>
          <li><strong>Android:</strong> API 21+ (Android 5.0+)</li>
          <li><strong>Features:</strong> In-App Purchases, PDF Export, Share functionality</li>
        </ul>

        <h4>Feedback & Suggestions</h4>
        <p>We value your feedback! If you have suggestions for new features or improvements, please email us at sainineeraj1234@gmail.com</p>

        <div style={{ backgroundColor: '#e8f4fd', padding: '15px', borderRadius: '5px', margin: '20px 0' }}>
          <h5>📱 App Information</h5>
          <p><strong>Developer:</strong> Neeraj Kumar</p>
          <p><strong>Email:</strong> sainineeraj1234@gmail.com</p>
          <p><strong>Platform:</strong> Flutter (iOS & Android)</p>
        </div>
      </div>
    </div>
  );
}

